import { render, staticRenderFns } from "./SpOrdering.vue?vue&type=template&id=7039c531&scoped=true&"
import script from "./SpOrdering.vue?vue&type=script&lang=js&"
export * from "./SpOrdering.vue?vue&type=script&lang=js&"
import style0 from "./SpOrdering.vue?vue&type=style&index=0&id=7039c531&scoped=true&lang=css&"
import style1 from "./SpOrdering.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7039c531",
  null
  
)

export default component.exports